import VideoDropzone from './VideoDropzone';

export default VideoDropzone;
